import Date from "./Date";
import Input from "./Input";
import Select from "./Select";
export default {
  Date,
  Input,
  Select
};
